/** Ford Oracle / Oracle Learn roster status display order. */
const ORACLE_STATUS_RANK = {
  "enrollment-pending": 0,
  "enrollment-sent": 1,
  "enrollment-success": 2,
  "completion-pending": 3,
  "completion-sent": 4,
  "completion-success": 5,
};

const getCheckInTimestamp = (enrollment) => {
  const raw = enrollment?.checkedInDate;
  if (raw == null || raw === "") return null;
  const ts = new Date(raw).getTime();
  return Number.isFinite(ts) ? ts : null;
};

/** Latest check-in first; learners without a check-in date sort last within the status group. */
const compareByCheckInDateDesc = (a, b) => {
  const aTs = getCheckInTimestamp(a);
  const bTs = getCheckInTimestamp(b);
  if (aTs == null && bTs == null) return 0;
  if (aTs == null) return 1;
  if (bTs == null) return -1;
  return bTs - aTs;
};

/**
 * Sort Ford Oracle Manage Roster rows:
 * enrollment statuses first (pending → sent → success), then completion statuses,
 * then by check-in date/time descending within the same status (latest / newest first).
 * Preserves non-array input (undefined/null) so callers' loading checks stay unchanged.
 */
export function sortOracleRosterEnrollments(enrollments) {
  if (!Array.isArray(enrollments)) return enrollments;

  return [...enrollments].sort((a, b) => {
    const rankA = ORACLE_STATUS_RANK[a?.hcmDlStatus] ?? 999;
    const rankB = ORACLE_STATUS_RANK[b?.hcmDlStatus] ?? 999;
    if (rankA !== rankB) return rankA - rankB;
    return compareByCheckInDateDesc(a, b);
  });
}
